import type { ThreadSummary } from "@dfws/contracts";

/** What a list row needs, independent of where it came from. */
export interface ListThread {
  id: string;
  latestMessageId: number;
  from: { name: string; email: string };
  subject: string;
  snippet: string;
  date: Date;
  unread: boolean;
  starred: boolean;
  count: number;
  hasAttachment: boolean;
  labels: { name: string; hue: number }[];
}

export function toListThread(t: ThreadSummary): ListThread {
  return {
    id: t.key,
    latestMessageId: t.latestMessageId,
    from: { name: t.from.name || t.from.email || "(unknown sender)", email: t.from.email },
    subject: t.subject,
    snippet: t.snippet,
    date: new Date(t.date),
    unread: t.unread,
    starred: t.starred,
    count: t.count,
    hasAttachment: t.hasAttachment,
    labels: [],
  };
}
